import axios from "axios";
import store from "@/store";
import customModal from "../customModal/customModal.vue";

export default {
    name: "AssignRuleApprover",
    components: {
        customModal
    },
    data() {
        return {
            head: {},
            baseurl: process.env.VUE_APP_Service_URL,
            studyid: store.getters.getStudyIs,
            designationList: [],
            roleList: [],

        };
    },
    mounted() {
        const idtoken = store.getters.getIdToken;
        this.head = {
            headers: {
                Authorization: "Bearer " + idtoken,
                "Content-Type": "application/json",
            },
        };
        window.addEventListener("studyIdChanged", (event) => {
            this.idToken = store.getters.getIdToken;
            this.listRoles();
        });
        this.listRoles();
    },
    methods: {
        async listRoles() {
            const idtoken = store.getters.getIdToken;
            await axios
                .get(`${this.baseurl}/account-core/roles/search?`, this.head)
                .then((res) => {
                if (res.data?.data?.length) {
                    this.roleList = res.data.data.sort((a, b) => a.role_Name.localeCompare(b.role_Name));
                }
                })
                .catch((err) => {
                console.error(err);
                });
        },
        async onChange(selected) {
            this.showSave = true;
            this.approvals.approveList = [];
            this.approvals.version = this.selectedversionid;
            this.userobject = [];
            this.userList = [];
            this.isSelectedUser = [];
            this.isRequired = [];

            if (Array.isArray(selected)) {
                for (let roleId of selected) {
                await this.getDesignationUser(roleId);
                }
            } else if (selected) {
                await this.getDesignationUser(selected);
            }
        },
    },
};